import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=60bb356f&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=60bb356f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bb356f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60bb356f')) {
      api.createRecord('60bb356f', component.options)
    } else {
      api.reload('60bb356f', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=60bb356f&scoped=true&", function () {
      api.rerender('60bb356f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2t3PjWpipAXIW/JS/comp/SearchFilterTokens.vue"
export default component.exports